import { analytics } from './mixpanel';

function isLocalhost() {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === '[::1]' ||
    hostname.endsWith('.localhost')
  );
}

function isLive() {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname.includes('monrapidoo.com');
}

export function setupAnalytics(bus, router) {
  if (isLocalhost()) {
    console.log('[Analytics] Skipping setup on localhost');
    return;
  }

  if (!isLive()) {
    console.log('[Analytics] Skipping setup on non-live');
    return;
  }

  analytics.init(router);
  analytics.setupBusListeners(bus);
}

export { analytics };
export default analytics;
